import gsap from 'gsap'
import { logger, Viewport } from './utils'
import Swup from 'swup'

// Cache Swup instance globally
let swup: Swup

export function pageLoadAnimation(
  { afterPageLoadCallback, hideSidebarMenu } = {
    afterPageLoadCallback: () => {},
    hideSidebarMenu: () => {},
  }
) {
  swup = new Swup({ cache: false })

  const loadingOverlay = document.querySelector('.loading-overlay')
  const loadingShapesListParent = document.querySelector('.loading__shapes')
  const loadingImageWrapper = document.querySelector('.loading__image-wrapper')

  if (!loadingOverlay || !loadingShapesListParent || !loadingShapesListParent.children.length || !loadingImageWrapper) {
    logger.error('Required DOM elements not found for page transition.')
    return
  }

  // append total 8 childds including previous one
  const firstShape = loadingShapesListParent.children[0]
  loadingShapesListParent.innerHTML = ''
  const totalParts = Viewport.width() <= 991 ? 6 : 8
  for (let i = 0; i < totalParts; i++) {
    loadingShapesListParent.appendChild(firstShape.cloneNode(true))
  }

  // Randomize the order of the loading shapes
  const shuffledLoadingShapesList = Array.from(loadingShapesListParent.children).sort(() => 0.5 - Math.random())

  /**
   * 1. On Load:
   * 2. After load: loading shapes height decrease.
   *    After that, fade out loading overlay.
   * 3. Before changing page:
   *    Reverse timeline.
   */
  const tl = gsap.timeline({
    defaults: { duration: 1, ease: 'power4.inOut' },
    paused: true,
  })
  tl.set(loadingShapesListParent, { willChange: 'transform', transformOrigin: 'right' })
  tl.set(shuffledLoadingShapesList, { willChange: 'transform', transformOrigin: 'top', scaleX: 1.03 })

  if (Viewport.width() <= 700) {
    // Phone and Phone Landscape
    tl.to(loadingShapesListParent, { scaleX: 0 })
    tl.to(loadingImageWrapper, { opacity: 0, duration: 0.5 }, '<')
  } else {
    // Tablet and Desktop
    tl.to(shuffledLoadingShapesList, { scaleY: 0, stagger: 0.1 })
    tl.to(loadingImageWrapper, { opacity: 0 }, '<')
  }
  tl.to(loadingOverlay, { opacity: 0, pointerEvents: 'none', duration: 0.1 })

  // Simplified Swup hooks
  swup.hooks.on('enable', () => tl.play().then(afterPageLoadCallback))
  swup.hooks.on('animation:out:await', async () => {
    hideSidebarMenu()
    await tl.reverse()
  })
  swup.hooks.on('animation:in:await', async () => {
    hideSidebarMenu()
    await tl.play().then(afterPageLoadCallback)
  })

  /**
   * Manual fix for back/forward button.
   * When user presses back/forward button, the page is not reloaded.
   */

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      swup.destroy()
      logger.info('User pressed back/forward. pageshow event triggered.')
      tl.play()
      window.lenis?.start()
    }
  })
  window.addEventListener('pagehide', (event) => {
    if (event.persisted) {
      logger.info('User pressed back/forward. pagehide event triggered.')
      hideSidebarMenu()
      tl.reverse()
      window.lenis?.stop()
    }
  })
}
